import { type SubscriptionOptions } from '@reduxjs/toolkit/query/react';
import { createGraphqlServiceWithTransform, type UseQueryResult } from '@repo/services';
import { useDispatch } from 'react-redux';

import { type UsersType } from '../queries/referencedConfigService';
import { setUsers } from '../stores/configDetails';

export const GetOwnerDropdownData = `
  query GetOwnerDropdownData($searchText: String) {
    users(searchText: $searchText) {
      id
      userUuid
      email
      firstName
      lastName
      fullName
    }
  }
`;

export interface GetOwnerDropdownDataType {
  users: UsersType[];
}

const { useGetGraphqlDataQuery } = createGraphqlServiceWithTransform<GetOwnerDropdownDataType>(
  'USER_QUERY',
  (response, dispatch) => {
    const userMap = response.users.reduce((acc: { [key: string]: UsersType }, user: UsersType) => {
      acc[user.userUuid] = user;
      return acc;
    }, {} as Record<string, UsersType>);

    dispatch(setUsers({ data: userMap }));
    return response;
  },
);

const useFetchOwnerDetails = (
  searchText: string = '',
  queryAdditionalArgs: SubscriptionOptions & { skip?: boolean } = {},
) => {
  const dispatch = useDispatch();
  const { data, isLoading, isFetching } = useGetGraphqlDataQuery<UseQueryResult<GetOwnerDropdownDataType>>(
    {
      document: GetOwnerDropdownData,
      variables: {
        searchText,
      },
      dispatch,
    },
    {
      ...queryAdditionalArgs,
    },
  );

  return {
    data,
    isLoading,
    isFetching,
  };
};

export default useFetchOwnerDetails;
